import React from "react";
import { useReservation } from "../../context/reservation";
import SummaryPanelHeader from "../common/SummaryPanelHeader";
import PanelGuestsList from "../common/PanelGuestsList"


function GuestsList() {
  const { data: reservation } = useReservation();

 
  const guests = reservation?.guest_group?.members;
  const currentRegisteredGuests = guests?.length || 0;
  const totalGuests = reservation?.guest_group?.number_of_guests;
  const registrationStatus = guests?.length === totalGuests;

  return (
    <>
      <SummaryPanelHeader title="Guest List" status={registrationStatus} />
			<PanelGuestsList guests={guests} totalGuests={totalGuests} currentRegisteredGuests={currentRegisteredGuests} />
    </>
  );
}

export { GuestsList };
